import React from 'react';
import { EmptyState } from 'onefaceui-react-components';
import { getResourceTo } from 'react/utils/utils';
import { TelematicsMultiSourceContainer } from './TelematicsMultisource.styles';

export function TelemeticEmptyState() {
  return (
    <TelematicsMultiSourceContainer
      style={{ alignItems: 'center', justifyContent: 'center' }}
    >
      <EmptyState message={getResourceTo('TelemeticsChart.noData.message')} />
    </TelematicsMultiSourceContainer>
  );
}

export default TelemeticEmptyState;
